(function () {
  'use strict';

  var GIFT_CARD_PRODUCT_IDS = [
    9389312672073,
    9418861576521,
    9418862690633,
    9418863083849,
    9418866622793
  ];
  // FKLN-471: advent calendars must stay one-time — never convert via subscription booster.
  var ADVENT_CALENDAR_PRODUCT_IDS = [
    9853459038537, // calendrier-de-lavent-chat
    9853386555721  // calendrier-de-lavent-pour-chien
  ];
  // FKLN-472: widget + subscription only for these collections (abonnement V2 + part 2).
  var DEFAULT_SUBSCRIPTION_COLLECTIONS = ['abonnement-2', 'abonnement-2-part-2'];
  var subscriptionAllowlistState = 'idle';
  var subscriptionProductIds = null;
  var subscriptionAllowlistPromise = null;

  function parseCollectionHandles(raw) {
    if (!raw) return DEFAULT_SUBSCRIPTION_COLLECTIONS.slice();
    var handles = String(raw).split(',').map(function (handle) {
      return handle.trim();
    }).filter(Boolean);
    return handles.length ? handles : DEFAULT_SUBSCRIPTION_COLLECTIONS.slice();
  }

  function fetchCollectionProductIds(handle) {
    var ids = [];

    function loadPage(page) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var url = root + 'collections/' + encodeURIComponent(handle) + '/products.json?limit=250&page=' + page;
      return fetch(url, { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('Collection fetch failed');
          return res.json();
        })
        .then(function (data) {
          var products = data && data.products ? data.products : [];
          products.forEach(function (product) {
            if (product && product.id) ids.push(product.id);
          });
          if (products.length === 250) return loadPage(page + 1);
          return ids;
        });
    }

    return loadPage(1);
  }

  function ensureSubscriptionAllowlist(handles) {
    if (subscriptionAllowlistState === 'ready' || subscriptionAllowlistState === 'failed') {
      return Promise.resolve(subscriptionAllowlistState);
    }
    if (subscriptionAllowlistPromise) return subscriptionAllowlistPromise;

    subscriptionAllowlistState = 'loading';
    var list = handles && handles.length ? handles : DEFAULT_SUBSCRIPTION_COLLECTIONS.slice();
    subscriptionAllowlistPromise = Promise.all(list.map(function (handle) {
      return fetchCollectionProductIds(handle).catch(function () { return []; });
    })).then(function (groups) {
      var ids = {};
      var count = 0;
      groups.forEach(function (group) {
        group.forEach(function (id) {
          ids[id] = true;
          count += 1;
        });
      });
      if (!count) {
        subscriptionAllowlistState = 'failed';
        subscriptionProductIds = null;
        return subscriptionAllowlistState;
      }
      subscriptionProductIds = ids;
      subscriptionAllowlistState = 'ready';
      return subscriptionAllowlistState;
    }).catch(function () {
      subscriptionAllowlistState = 'failed';
      subscriptionProductIds = null;
      return subscriptionAllowlistState;
    });

    return subscriptionAllowlistPromise;
  }

  function isOutsideSubscriptionCollections(item) {
    if (!item || subscriptionAllowlistState !== 'ready' || !subscriptionProductIds) return false;
    return !subscriptionProductIds[item.product_id];
  }
  function getGobeletVariantIds() {
    var config = window.subAutoGiftConfig || {};
    var ids = [];
    if (config.dogVariantId) ids.push(parseInt(config.dogVariantId, 10));
    if (config.catVariantId) ids.push(parseInt(config.catVariantId, 10));
    if (Array.isArray(config.legacyVariantIds)) {
      config.legacyVariantIds.forEach(function (id) {
        ids.push(parseInt(id, 10));
      });
    }
    ids = ids.filter(function (id) { return !isNaN(id); });
    return ids.length ? ids : [52907219779913, 52907179245897];
  }
  var STORAGE_KEY_PREVIOUS_DISCOUNT = 'subscription_booster_previous_discount';
  var STORAGE_KEY_ACTIVE = 'subscription_booster_active';
  var STORAGE_KEY_FREQUENCY = 'subscription_booster_frequency';
  var STORAGE_KEY_PRE_ACTIVATION_PRICES = 'subscription_booster_pre_activation_prices';
  var discountUpdateInFlight = null;
  var discountUpdateDepth = 0;
  var MAX_DISCOUNT_UPDATE_DEPTH = 3;

  function setBoosterUpdating(active) {
    window.__subscriptionBoosterUpdating = !!active;
    // Pause GWP embed — it patches cart fetch/XHR and would re-enter during rebuild.
    window.__GWP_PAUSED = !!active;
  }

  function isBoosterUpdating() {
    return !!window.__subscriptionBoosterUpdating;
  }

  function isFreeGiftProperty(item) {
    if (!item || !item.properties) return false;
    var props = item.properties;
    if (props._giveaway) return true;
    if (props._free_gift === true || props._free_gift === 'true') return true;
    if (props.__free_gift) return true;
    return false;
  }

  function isAutoGiftItem(item) {
    if (!item) return false;
    if (isFreeGiftProperty(item)) return true;
    return getGobeletVariantIds().indexOf(item.variant_id) > -1;
  }

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '€';
  }

  function parseVariantIds(raw) {
    if (!raw) return [];
    return raw.split(',').map(function (v) {
      return parseInt(v.trim(), 10);
    }).filter(function (n) {
      return !isNaN(n);
    });
  }

  function getCartDiscountCodes(cart) {
    return Array.isArray(cart && cart.discount_codes) ? cart.discount_codes : [];
  }

  function getApplicableDiscountCodes(cart) {
    return getCartDiscountCodes(cart)
      .filter(function (d) { return d.applicable; })
      .map(function (d) { return d.code; });
  }

  function getCurrentDiscountPercentage(cart) {
    var apps = cart.cart_level_discount_applications || [];
    if (apps.length > 0 && apps[0].value_type === 'percentage') {
      return parseFloat(apps[0].value) || 0;
    }

    var original = 0;
    var final = 0;
    (cart.items || []).forEach(function (item) {
      original += item.original_line_price != null ? item.original_line_price : item.line_price;
      final += item.final_line_price != null ? item.final_line_price : item.line_price;
    });

    if (original <= 0) return 0;
    return Math.round((1 - final / original) * 100);
  }

  function isAdventCalendarItem(item) {
    if (!item) return false;
    if (ADVENT_CALENDAR_PRODUCT_IDS.indexOf(item.product_id) > -1) return true;

    var handle = String(item.handle || '').toLowerCase();
    if (handle.indexOf('calendrier-de-lavent') > -1) return true;

    if (typeof all_products !== 'undefined') {
      for (var i = 0; i < all_products.length; i++) {
        var entry = all_products[i];
        if (!entry || !entry.product || entry.product.id !== item.product_id) continue;
        var productHandle = String(entry.product.handle || '').toLowerCase();
        if (productHandle.indexOf('calendrier-de-lavent') > -1) return true;
        break;
      }
    }

    var title = String(item.product_title || item.title || '').toLowerCase();
    return title.indexOf('calendrier') > -1 && title.indexOf('avent') > -1;
  }

  function isExcludedItem(item, excludedVariantIds) {
    if (GIFT_CARD_PRODUCT_IDS.indexOf(item.product_id) > -1) return true;
    if (isAdventCalendarItem(item)) return true;
    if (getGobeletVariantIds().indexOf(item.variant_id) > -1) return true;
    if (excludedVariantIds.indexOf(item.variant_id) > -1) return true;
    if (isFreeGiftProperty(item)) return true;

    if (typeof all_products !== 'undefined') {
      for (var i = 0; i < all_products.length; i++) {
        var entry = all_products[i];
        if (!entry || !entry.product || entry.product.id !== item.product_id) continue;
        if (entry.product.tags && entry.product.tags.indexOf('echantillons') > -1) return true;
        break;
      }
    }

    var title = (item.variant_title || item.title || '').toLowerCase();
    if (title.indexOf('chantillon') > -1 || title.indexOf('unité') > -1) return true;
    if (isOutsideSubscriptionCollections(item)) return true;

    return false;
  }

  function hasSellingPlanForItem(item) {
    if (typeof all_products === 'undefined') return true;

    for (var i = 0; i < all_products.length; i++) {
      var entry = all_products[i];
      if (!entry || !entry.product || entry.product.id !== item.product_id) continue;

      if (entry.product.tags && entry.product.tags.indexOf('echantillons') > -1) return false;

      var variants = entry.variants || [];
      for (var j = 0; j < variants.length; j++) {
        var variant = variants[j].variant;
        if (!variant || variant.id !== item.variant_id) continue;
        var allocations = variant.selling_plan_allocations || [];
        return allocations.length > 0;
      }
    }

    return false;
  }

  function getEligibleItems(cart, excludedVariantIds) {
    return (cart.items || []).filter(function (item) {
      return !isExcludedItem(item, excludedVariantIds) && hasSellingPlanForItem(item);
    });
  }

  function getVariantFromAllProducts(variantId, productId) {
    if (typeof all_products === 'undefined') return null;
    for (var i = 0; i < all_products.length; i++) {
      var entry = all_products[i];
      if (!entry || !entry.product || entry.product.id !== productId) continue;
      var variants = entry.variants || [];
      for (var j = 0; j < variants.length; j++) {
        var variant = variants[j].variant;
        if (variant && variant.id === variantId) return variant;
      }
    }
    return null;
  }

  function getSubscriptionUnitPriceCents(item, subscriptionDiscountPct) {
    var variant = getVariantFromAllProducts(item.variant_id, item.product_id);
    var allocations = variant && variant.selling_plan_allocations;
    if (allocations && allocations.length > 0) {
      for (var i = 0; i < allocations.length; i++) {
        if (allocations[i].price > 0) return allocations[i].price;
      }
    }
    var baseUnit = item.original_price || item.price;
    var rate = (parseFloat(subscriptionDiscountPct) || 20) / 100;
    return Math.round(baseUnit * (1 - rate));
  }

  function getLineOriginalCents(item) {
    if (typeof item.original_line_price === 'number' && item.original_line_price != null) {
      return item.original_line_price;
    }
    return (item.original_price || item.price) * item.quantity;
  }

  function getLineDiscountedCents(item) {
    var original = getLineOriginalCents(item);
    var finalLine = item.final_line_price;
    var hasLineAlloc = (item.line_level_discount_allocations && item.line_level_discount_allocations.length > 0) ||
      (item.discount_allocations && item.discount_allocations.length > 0);

    if (typeof finalLine === 'number' && finalLine < original) {
      return finalLine;
    }
    if (hasLineAlloc && typeof finalLine === 'number') {
      return finalLine;
    }
    if (typeof item.discounted_price === 'number' && item.discounted_price < item.original_price) {
      return item.discounted_price * item.quantity;
    }
    if (typeof item.line_price === 'number' && item.line_price < original) {
      return item.line_price;
    }
    return original;
  }

  function getEligibleCurrentTotalCents(cart, eligibleItems) {
    var allItems = cart.items || [];
    var cartOriginalTotal = 0;
    var cartDiscountedTotal = 0;

    allItems.forEach(function (item) {
      cartOriginalTotal += getLineOriginalCents(item);
      cartDiscountedTotal += getLineDiscountedCents(item);
    });

    var eligibleOriginal = 0;
    var eligibleDiscounted = 0;

    eligibleItems.forEach(function (item) {
      eligibleOriginal += getLineOriginalCents(item);
      eligibleDiscounted += getLineDiscountedCents(item);
    });

    if (eligibleDiscounted < eligibleOriginal) {
      return eligibleDiscounted;
    }

    if (cartDiscountedTotal < cartOriginalTotal && cartOriginalTotal > 0) {
      return Math.round(eligibleOriginal * (cartDiscountedTotal / cartOriginalTotal));
    }

    if (typeof cart.total_price === 'number' && cart.total_price < cartOriginalTotal && cartOriginalTotal > 0) {
      return Math.round(eligibleOriginal * (cart.total_price / cartOriginalTotal));
    }

    return eligibleOriginal;
  }

  function calculateExtraSavings(cart, eligibleItems, config) {
    var subscriptionDiscountPct = parseFloat(config.subscriptionDiscount) || 20;
    var targetDiscountPct = parseFloat(config.targetDiscount) || 30;
    var promoDiscountPct = Math.max(0, targetDiscountPct - subscriptionDiscountPct);
    var promoRate = promoDiscountPct / 100;

    var currentTotal = getEligibleCurrentTotalCents(cart, eligibleItems);

    var subscriptionSubtotal = eligibleItems.reduce(function (sum, item) {
      return sum + getSubscriptionUnitPriceCents(item, subscriptionDiscountPct) * item.quantity;
    }, 0);

    var projectedWithSubscriptionAndPromo = Math.round(subscriptionSubtotal * (1 - promoRate));

    return Math.max(0, currentTotal - projectedWithSubscriptionAndPromo);
  }

  function getOneTimeUnitPriceCents(item) {
    var allocation = item.selling_plan_allocation;
    if (allocation && allocation.compare_at_price > allocation.price) {
      return allocation.compare_at_price;
    }

    var variant = getVariantFromAllProducts(item.variant_id, item.product_id);
    if (variant) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        return variant.compare_at_price;
      }
      return variant.price || item.original_price || item.price;
    }

    return item.original_price || item.price;
  }

  function getOneTimeLineTotalCents(item) {
    return getOneTimeUnitPriceCents(item) * item.quantity;
  }

  function calculateActualSavings(cart, eligibleItems) {
    var oneTimeTotal = 0;
    var currentTotal = 0;

    eligibleItems.forEach(function (item) {
      oneTimeTotal += getOneTimeLineTotalCents(item);
      currentTotal += getLineDiscountedCents(item);
    });

    return Math.max(0, oneTimeTotal - currentTotal);
  }

  function storePreActivationPrices(cart, config) {
    var eligibleItems = getEligibleItems(cart, config.excludedVariantIds);
    var prePrices = {};

    eligibleItems.forEach(function (item) {
      if (!item.quantity) return;
      prePrices[String(item.variant_id)] = getOneTimeUnitPriceCents(item);
    });

    sessionStorage.setItem(STORAGE_KEY_PRE_ACTIVATION_PRICES, JSON.stringify(prePrices));
  }

  function clearPreActivationPrices() {
    sessionStorage.removeItem(STORAGE_KEY_PRE_ACTIVATION_PRICES);
  }

  function getDisplaySavings(cart, eligibleItems, config, checked) {
    if (checked) {
      // Total savings: one-time / compare-at displayed price vs current discounted cart lines.
      // Not tied to the promo code that was active before booster activation.
      return calculateActualSavings(cart, eligibleItems);
    }
    return calculateExtraSavings(cart, eligibleItems, config);
  }

  function isBoosterActive() {
    return sessionStorage.getItem(STORAGE_KEY_ACTIVE) === 'true';
  }

  function setBoosterActive(active) {
    if (active) {
      sessionStorage.setItem(STORAGE_KEY_ACTIVE, 'true');
    } else {
      sessionStorage.removeItem(STORAGE_KEY_ACTIVE);
      clearPreActivationPrices();
    }
  }

  function clearBoosterSession() {
    setBoosterActive(false);
    sessionStorage.removeItem(STORAGE_KEY_PREVIOUS_DISCOUNT);
    sessionStorage.removeItem(STORAGE_KEY_FREQUENCY);
  }

  function hasValidBoosterSession(cart, config) {
    if (!isBoosterActive()) return false;

    var raw = sessionStorage.getItem(STORAGE_KEY_PRE_ACTIVATION_PRICES);
    if (!raw) return false;

    var prePrices;
    try {
      prePrices = JSON.parse(raw);
    } catch (e) {
      return false;
    }

    var eligibleItems = getEligibleItems(cart, config.excludedVariantIds);
    if (!eligibleItems.length) return false;

    var variantIds = eligibleItems.map(function (item) {
      return String(item.variant_id);
    }).sort();

    var preKeys = Object.keys(prePrices).sort();
    if (variantIds.length !== preKeys.length) return false;

    for (var i = 0; i < variantIds.length; i++) {
      if (variantIds[i] !== preKeys[i]) return false;
    }

    return true;
  }

  function reconcileBoosterSession(cart, config) {
    var eligibleItems = getEligibleItems(cart, config.excludedVariantIds);
    if (!eligibleItems.length) {
      if (isBoosterActive()) clearBoosterSession();
      return;
    }

    var allSubscription = cartHasEligibleSubscription(eligibleItems);
    var allOneTime = eligibleItems.every(function (item) {
      return !item.selling_plan_allocation;
    });

    if (allSubscription && !hasValidBoosterSession(cart, config)) {
      clearBoosterSession();
      return;
    }

    if (allOneTime && isBoosterActive()) {
      clearBoosterSession();
    }
  }

  function normalizeDiscountCodes(codes) {
    return (codes || []).map(function (code) {
      return String(code).trim().toUpperCase();
    }).filter(Boolean).sort();
  }

  function discountsAlreadyApplied(cart, desiredCodes) {
    var desired = normalizeDiscountCodes(desiredCodes);
    var current = normalizeDiscountCodes(getApplicableDiscountCodes(cart));

    if (desired.length !== current.length) return false;

    for (var i = 0; i < desired.length; i++) {
      if (desired[i] !== current[i]) return false;
    }

    return true;
  }

  function cartHasMixedPurchaseTypes(eligibleItems) {
    var hasSubscription = false;
    var hasOneTime = false;

    eligibleItems.forEach(function (item) {
      if (item.selling_plan_allocation) {
        hasSubscription = true;
      } else {
        hasOneTime = true;
      }
    });

    return hasSubscription && hasOneTime;
  }

  function shouldShowBooster(cart, config) {
    var eligibleItems = getEligibleItems(cart, config.excludedVariantIds);
    if (eligibleItems.length === 0) return false;

    if (cartHasMixedPurchaseTypes(eligibleItems)) {
      return false;
    }

    var allOneTime = eligibleItems.every(function (item) {
      return !item.selling_plan_allocation;
    });
    var allSubscription = cartHasEligibleSubscription(eligibleItems);

    if (allSubscription) {
      return hasValidBoosterSession(cart, config);
    }

    if (allOneTime) {
      var discountPct = getCurrentDiscountPercentage(cart);
      if (discountPct >= config.targetDiscount) return false;
      return true;
    }

    return false;
  }

  function cartHasEligibleSubscription(eligibleItems) {
    return eligibleItems.length > 0 && eligibleItems.every(function (item) {
      return !!item.selling_plan_allocation;
    });
  }

  function getCartSubscriptionFrequency(eligibleItems) {
    for (var i = 0; i < eligibleItems.length; i++) {
      var item = eligibleItems[i];
      if (!item.selling_plan_allocation) continue;

      var props = item.properties;
      if (props && props._shipping_interval_frequency) {
        return String(props._shipping_interval_frequency).trim();
      }

      var plan = item.selling_plan_allocation.selling_plan;
      if (plan && plan.name) {
        var match = plan.name.match(/(\d+)\s*jours/i);
        if (match) return match[1];
      }
    }
    return null;
  }

  function isToggleChecked(cart, config) {
    var eligibleItems = getEligibleItems(cart, config.excludedVariantIds);
    if (eligibleItems.length === 0) return false;
    return cartHasEligibleSubscription(eligibleItems);
  }

  function fetchProduct(handle) {
    if (window.getProductForSubscription) {
      return window.getProductForSubscription(handle);
    }
    return fetch(window.Shopify.routes.root + 'products/' + handle + '.js', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
    }).then(function (res) { return res.json(); });
  }

  function findSellingPlan(product, frequency) {
    if (!product || !product.selling_plan_groups || !product.selling_plan_groups[0]) return null;
    var plans = product.selling_plan_groups[0].selling_plans || [];
    var freqStr = String(frequency);

    for (var i = 0; i < plans.length; i++) {
      if (parseFrequencyFromPlan(plans[i]) === freqStr) {
        return plans[i];
      }
    }

    var needle = 'Livraison tous les ' + frequency + ' jours';
    for (var j = 0; j < plans.length; j++) {
      if (plans[j].name && plans[j].name.indexOf(needle) > -1) {
        return plans[j];
      }
    }

    return plans[0] || null;
  }

  function parseFrequencyFromPlan(plan) {
    if (!plan) return null;

    if (plan.options && plan.options[0] && plan.options[0].value) {
      return String(plan.options[0].value).replace(/\s*Day\(s\)/i, '').trim();
    }

    if (plan.name) {
      var match = plan.name.match(/(\d+)\s*jours/i);
      if (match) return match[1];
    }

    return null;
  }

  function getFrequenciesFromProduct(product) {
    if (!product || !product.selling_plan_groups || !product.selling_plan_groups[0]) return [];

    var plans = product.selling_plan_groups[0].selling_plans || [];
    var frequencies = [];

    plans.forEach(function (plan) {
      var value = parseFrequencyFromPlan(plan);
      if (value && frequencies.indexOf(value) === -1) {
        frequencies.push(value);
      }
    });

    return frequencies.sort(function (a, b) {
      return parseInt(a, 10) - parseInt(b, 10);
    });
  }

  function intersectFrequencyLists(lists) {
    if (!lists.length) return [];

    return lists.reduce(function (common, list) {
      if (!common.length) return list.slice();
      return common.filter(function (value) {
        return list.indexOf(value) > -1;
      });
    }, lists[0].slice());
  }

  function getCommonFrequenciesForCart(cart, config) {
    var eligibleItems = getEligibleItems(cart, config.excludedVariantIds);
    var handles = [];

    eligibleItems.forEach(function (item) {
      if (item.handle && handles.indexOf(item.handle) === -1) {
        handles.push(item.handle);
      }
    });

    if (!handles.length) {
      return Promise.resolve([]);
    }

    return Promise.all(handles.map(function (handle) {
      return fetchProduct(handle).then(getFrequenciesFromProduct);
    })).then(function (frequencyLists) {
      var validLists = frequencyLists.filter(function (list) {
        return list.length > 0;
      });

      if (!validLists.length) return [];

      var common = intersectFrequencyLists(validLists);
      return common.length ? common : validLists[0];
    });
  }

  function populateFrequencySelect(select, frequencies, selectedFrequency, defaultFrequency) {
    if (!select) return selectedFrequency;

    var previousValue = selectedFrequency || select.value || defaultFrequency;
    select.innerHTML = '';

    frequencies.forEach(function (frequency) {
      var option = document.createElement('option');
      option.value = frequency;
      option.textContent = 'Tous les ' + frequency + ' jours';
      select.appendChild(option);
    });

    if (frequencies.length === 0) {
      return previousValue;
    }

    if (frequencies.indexOf(previousValue) > -1) {
      select.value = previousValue;
      return previousValue;
    }

    if (frequencies.indexOf(defaultFrequency) > -1) {
      select.value = defaultFrequency;
      return defaultFrequency;
    }

    select.value = frequencies[0];
    return frequencies[0];
  }

  function updateBoosterCartState(checked) {
    var sideCart = document.querySelector('[data-side-cart]');
    if (sideCart) {
      sideCart.classList.toggle('subscription-booster-active', !!checked);
    }
  }

  function cartClear() {
    return fetch('/cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
    }).then(function (r) {
      if (!r.ok) throw new Error('Cart clear failed');
      return r.json();
    });
  }

  function cartAddItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('Cart add failed');
      return r.json();
    });
  }

  function updateCartDiscounts(codes) {
    var desiredCodes = Array.isArray(codes)
      ? codes.filter(Boolean)
      : (codes ? [String(codes)] : []);

    if (discountUpdateInFlight) {
      return discountUpdateInFlight.then(function (cart) {
        if (discountsAlreadyApplied(cart, desiredCodes)) return cart;
        if (discountUpdateDepth >= MAX_DISCOUNT_UPDATE_DEPTH) return cart;
        discountUpdateDepth += 1;
        return updateCartDiscounts(codes).finally(function () {
          discountUpdateDepth = Math.max(0, discountUpdateDepth - 1);
        });
      });
    }

    var promise = fetch('/cart.json', { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart fetch failed');
        return r.json();
      })
      .then(function (cart) {
        if (discountsAlreadyApplied(cart, desiredCodes)) {
          return cart;
        }

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: desiredCodes.join(',') })
        }).then(function (r) {
          if (!r.ok) throw new Error('Discount update failed');
          return r.json();
        });
      });

    discountUpdateInFlight = promise.finally(function () {
      if (discountUpdateInFlight === promise) {
        discountUpdateInFlight = null;
      }
    });

    return promise;
  }

  function trackNavigation(name, clickText, eventType) {
    window.dispatchEvent(new CustomEvent('hb_navigation_click', {
      detail: {
        type: eventType || 'minicart_click',
        name: name,
        click_text: clickText,
        click_link: '/cart'
      }
    }));
  }

  function buildCartItemsPayload(cart, config, mode, frequency) {
    // Drop auto-gifts during rebuild — constructCart re-adds them after unlock.
    // Re-adding gifts here races with CartJS and causes loader loops.
    var sourceItems = (cart.items || []).filter(function (element) {
      return !isAutoGiftItem(element);
    });

    var promises = sourceItems.map(function (element) {
      var eligible = !isExcludedItem(element, config.excludedVariantIds) && hasSellingPlanForItem(element);

      if (mode === 'subscription' && eligible) {
        return fetchProduct(element.handle).then(function (product) {
          var plan = findSellingPlan(product, frequency);
          if (!plan) {
            return { id: element.variant_id, quantity: element.quantity };
          }
          return {
            id: element.variant_id,
            quantity: element.quantity,
            selling_plan: plan.id,
            properties: {
              '_shipping_interval_frequency': String(frequency),
              '_shipping_interval_unit_type': 'Days'
            }
          };
        });
      }

      return Promise.resolve({ id: element.variant_id, quantity: element.quantity });
    });

    return Promise.all(promises);
  }

  function switchAllToSubscription(cart, config, frequency) {
    var previousCodes = getApplicableDiscountCodes(cart).filter(function (code) {
      return code.toUpperCase() !== config.promoCode.toUpperCase();
    });
    sessionStorage.setItem(STORAGE_KEY_PREVIOUS_DISCOUNT, previousCodes.join(','));
    sessionStorage.setItem(STORAGE_KEY_FREQUENCY, String(frequency));
    storePreActivationPrices(cart, config);

    return buildCartItemsPayload(cart, config, 'subscription', frequency)
      .then(function (items) {
        return cartClear().then(function () {
          return cartAddItems(items);
        });
      })
      .then(function () {
        return updateCartDiscounts([config.promoCode]);
      })
      .then(function () {
        setBoosterActive(true);
        if (typeof window.syncDiscountBarFromCart === 'function') {
          return window.syncDiscountBarFromCart();
        }
        return true;
      });
  }

  function switchAllToOneTime(cart, config) {
    // clear + re-add without selling_plan. Omit auto-gifts so CartJS does not
    // fight us (add/remove gift loops that freeze the minicart loader).
    var items = (cart.items || [])
      .filter(function (element) {
        return !isAutoGiftItem(element);
      })
      .map(function (element) {
        return { id: element.variant_id, quantity: element.quantity };
      });

    return cartClear()
      .then(function () {
        if (!items.length) return null;
        return cartAddItems(items);
      })
      .then(function () {
        var previousCode = sessionStorage.getItem(STORAGE_KEY_PREVIOUS_DISCOUNT) || '';
        return updateCartDiscounts(previousCode ? previousCode.split(',').filter(Boolean) : []);
      })
      .then(function () {
        clearBoosterSession();
        if (typeof window.syncDiscountBarFromCart === 'function') {
          return window.syncDiscountBarFromCart();
        }
        return true;
      });
  }

  function updateSubscriptionFrequency(cart, config, frequency) {
    var discountCodes = getApplicableDiscountCodes(cart);
    sessionStorage.setItem(STORAGE_KEY_FREQUENCY, String(frequency));

    var subscriptionItems = getEligibleItems(cart, config.excludedVariantIds).filter(function (item) {
      return !!item.selling_plan_allocation;
    });

    if (subscriptionItems.length === 0) {
      return Promise.resolve();
    }

    var chain = Promise.resolve();

    subscriptionItems.forEach(function (item) {
      chain = chain.then(function () {
        return fetchProduct(item.handle).then(function (product) {
          var plan = findSellingPlan(product, frequency);
          if (!plan) {
            console.warn('[SubscriptionBooster] No selling plan for frequency', frequency, item.handle);
            return null;
          }

          var properties = Object.assign({}, item.properties || {}, {
            '_shipping_interval_frequency': String(frequency),
            '_shipping_interval_unit_type': 'Days'
          });

          return fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              id: item.key,
              quantity: item.quantity,
              selling_plan: plan.id,
              properties: properties
            })
          }).then(function (r) {
            if (!r.ok) throw new Error('Cart change failed');
            return r.json();
          });
        });
      });
    });

    return chain
      .then(function () {
        if (discountCodes.length > 0) {
          return updateCartDiscounts(discountCodes);
        }
      })
      .then(function () {
        if (typeof window.syncDiscountBarFromCart === 'function') {
          return window.syncDiscountBarFromCart();
        }
      });
  }

  function propertiesWithoutSubscription(item) {
    var properties = {};
    var source = item && item.properties ? item.properties : {};
    Object.keys(source).forEach(function (key) {
      if (key === '_shipping_interval_frequency' || key === '_shipping_interval_unit_type') return;
      if (source[key] === '' || source[key] == null) return;
      properties[key] = source[key];
    });
    return properties;
  }

  function revertForcedOneTimeItems(cart, config) {
    var targets = (cart.items || []).filter(function (item) {
      return item.selling_plan_allocation && isOutsideSubscriptionCollections(item) && !isAutoGiftItem(item);
    });
    if (!targets.length) return Promise.resolve(cart);

    setBoosterUpdating(true);
    var chain = Promise.resolve(cart);
    targets.forEach(function (item) {
      chain = chain.then(function () {
        // cart/change keeps blank property keys, and those keys get treated as a subscription.
        // Remove the line and add it back as a one-time purchase.
        return fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: 0 })
        }).then(function (res) {
          if (!res.ok) throw new Error('Failed to remove one-time line');
          return fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: item.variant_id,
                quantity: item.quantity,
                properties: propertiesWithoutSubscription(item)
              }]
            })
          });
        }).then(function (res) {
          if (!res.ok) throw new Error('Failed to restore one-time line');
          return fetch('/cart.js', { credentials: 'same-origin' }).then(function (cartRes) {
            return cartRes.json();
          });
        });
      });
    });

    return chain.then(function (updatedCart) {
      var stillSubscribed = (updatedCart.items || []).some(function (item) {
        return !!item.selling_plan_allocation;
      });
      if (stillSubscribed) return updatedCart;

      var promo = String(config.promoCode || '').toUpperCase();
      var codes = getApplicableDiscountCodes(updatedCart);
      var remaining = codes.filter(function (code) {
        return code.toUpperCase() !== promo;
      });
      if (!promo || remaining.length === codes.length) return updatedCart;
      return updateCartDiscounts(remaining);
    }).finally(function () {
      setBoosterUpdating(false);
    });
  }

  function showCartLoader() {
    var loader = document.querySelector('[data-cart-loader]');
    if (loader) loader.style.display = 'block';
  }

  function hideCartLoader() {
    var loader = document.querySelector('[data-cart-loader]');
    if (loader) loader.style.display = 'none';
  }

  function refreshCart(options) {
    var allowGiftSync = !options || options.allowGiftSync !== false;
    return fetch('/cart.json', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (typeof CartJS !== 'undefined') {
          CartJS.cart = cart;
        }
        if (typeof jQuery !== 'undefined') {
          // While locked, skip cart.requestComplete — it runs constructCart gift
          // mutations that re-enter CartJS and loop the loader.
          if (allowGiftSync && !isBoosterUpdating()) {
            jQuery(document).trigger('cart.requestComplete', cart);
          } else if (window.SubscriptionBooster && typeof window.SubscriptionBooster.update === 'function') {
            window.SubscriptionBooster.update(cart);
          }
        } else if (window.SubscriptionBooster && typeof window.SubscriptionBooster.update === 'function') {
          window.SubscriptionBooster.update(cart);
        }
        return cart;
      });
  }

  class SubscriptionBooster extends HTMLElement {
    constructor() {
      super();
      this.isProcessing = false;
      this.savingsRefreshTimer = null;
      this.frequencyLoadToken = 0;
      this.wasBoosterVisible = false;
      this.config = {
        excludedVariantIds: [],
        promoCode: 'ABO10',
        targetDiscount: 30,
        subscriptionDiscount: 20,
        defaultFrequency: '30',
        subscriptionCollections: DEFAULT_SUBSCRIPTION_COLLECTIONS.slice()
      };
      this.revertSignature = '';
    }

    connectedCallback() {
      this.readConfig();
      ensureSubscriptionAllowlist(this.config.subscriptionCollections);
      this.cacheElements();
      this.portalPopup();
      this.bindEvents();
      this.updateFromCart();
    }

    portalPopup() {
      if (!this.popup || this.popup.dataset.portaled === 'true') return;
      document.body.appendChild(this.popup);
      this.popup.dataset.portaled = 'true';
    }

    readConfig() {
      this.config.excludedVariantIds = parseVariantIds(this.getAttribute('data-variants-sans-abonnement'));
      this.config.promoCode = (this.getAttribute('data-promo-code') || 'ABO10').trim();
      this.config.targetDiscount = parseFloat(this.getAttribute('data-target-discount') || '30');
      this.config.subscriptionDiscount = parseFloat(this.getAttribute('data-subscription-discount') || '20');
      this.config.defaultFrequency = this.getAttribute('data-default-frequency') || '30';
      this.config.subscriptionCollections = parseCollectionHandles(this.getAttribute('data-subscription-collections'));
    }

    cacheElements() {
      this.card = this.querySelector('[data-booster-card]');
      this.toggle = this.querySelector('[data-booster-toggle]');
      this.savingsBlock = this.querySelector('[data-booster-savings]');
      this.savingsAmount = this.querySelector('[data-booster-savings-amount]');
      this.popupSavings = this.querySelector('[data-booster-popup-savings]');
      this.frequencyBlock = this.querySelector('[data-booster-frequency]');
      this.frequencySelect = this.querySelector('[data-booster-frequency-select]');
      this.loader = this.querySelector('[data-booster-loader]');
      this.popup = this.querySelector('[data-booster-popup]');
      this.knowMoreBtn = this.querySelector('[data-booster-know-more]');
    }

    bindEvents() {
      var self = this;

      if (this.toggle) {
        this.toggle.addEventListener('change', function () {
          self.onToggleChange(this.checked);
        });
      }

      if (this.frequencySelect) {
        this.frequencySelect.addEventListener('change', function () {
          self.onFrequencyChange(this.value);
        });
      }

      if (this.knowMoreBtn) {
        this.knowMoreBtn.addEventListener('click', function () {
          self.openPopup();
          trackNavigation('subscription_booster_know_more', 'know_more');
        });
      }

      var popupCloseTargets = this.popup
        ? this.popup.querySelectorAll('[data-booster-popup-close]')
        : [];
      popupCloseTargets.forEach(function (el) {
        el.addEventListener('click', function () {
          self.closePopup();
        });
      });

      if (typeof jQuery !== 'undefined') {
        jQuery(document).on('cart.requestDone.subscriptionBooster cart.requestComplete.subscriptionBooster cart.ready.subscriptionBooster', function (event, cart) {
          // Ignore cart events while a toggle/frequency update is in flight —
          // stale payloads can flip the toggle back to "on" mid-deactivation.
          if (self.isProcessing) return;

          if (cart && typeof cart.items !== 'undefined') {
            self.render(cart);
          } else {
            self.updateFromCart();
          }

          if (!self.classList.contains('hide')) {
            clearTimeout(self.savingsRefreshTimer);
            self.savingsRefreshTimer = setTimeout(function () {
              if (self.isProcessing) return;
              self.updateFromCart();
            }, 1200);
          }
        });
      }

      document.addEventListener('cart:updated', function () {
        if (self.isProcessing) return;
        self.updateFromCart();
      });
      document.addEventListener('cart:refresh', function () {
        if (self.isProcessing) return;
        self.updateFromCart();
      });
    }

    setActiveState(checked) {
      if (this.card) this.card.classList.toggle('is-active', checked);
      if (this.frequencyBlock) this.frequencyBlock.classList.toggle('hide', !checked);
      if (this.toggle && this.toggle.checked !== !!checked) {
        this.toggle.checked = !!checked;
      }
      updateBoosterCartState(checked);
    }

    setLoading(loading) {
      this.isProcessing = loading;
      this.classList.toggle('is-loading', loading);
      if (this.loader) this.loader.classList.add('hide');
      if (this.toggle) this.toggle.disabled = loading;
      if (this.frequencySelect) this.frequencySelect.disabled = loading;
      if (loading) {
        showCartLoader();
      } else {
        hideCartLoader();
      }
    }

    updateSavingsDisplay(cents) {
      var formatted = formatMoney(cents);
      if (this.savingsAmount) this.savingsAmount.textContent = formatted;
      if (this.popupSavings) this.popupSavings.textContent = formatted;
    }

    updateFromCart() {
      var self = this;
      fetch('/cart.json')
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); })
        .catch(function () {});
    }

    render(cart) {
      var self = this;

      if (subscriptionAllowlistState !== 'ready' && subscriptionAllowlistState !== 'failed') {
        this.classList.add('hide');
        ensureSubscriptionAllowlist(this.config.subscriptionCollections).then(function () {
          if (self.isProcessing) return;
          self.updateFromCart();
        });
        return;
      }

      var forcedOneTime = (cart.items || []).filter(function (item) {
        return item.selling_plan_allocation && isOutsideSubscriptionCollections(item) && !isAutoGiftItem(item);
      });
      if (forcedOneTime.length) {
        var signature = forcedOneTime.map(function (item) { return item.key; }).join('|');
        if (this.revertSignature !== signature) {
          this.revertSignature = signature;
          this.setLoading(true);
          revertForcedOneTimeItems(cart, this.config)
            .then(function (updatedCart) { self.render(updatedCart || cart); })
            .catch(function () { self.render(cart); })
            .finally(function () { self.setLoading(false); });
          return;
        }
      }

      reconcileBoosterSession(cart, this.config);

      var eligibleItems = getEligibleItems(cart, this.config.excludedVariantIds);
      var visible = shouldShowBooster(cart, this.config);
      var becameVisible = visible && !this.wasBoosterVisible;
      this.wasBoosterVisible = visible;
      this.classList.toggle('hide', !visible);

      if (!visible) {
        this.setActiveState(false);
        return;
      }

      var checked = isToggleChecked(cart, this.config);
      var savings = getDisplaySavings(cart, eligibleItems, this.config, checked);
      this.updateSavingsDisplay(savings);

      if (this.savingsBlock) {
        this.savingsBlock.classList.toggle('hide', savings <= 0);
      }

      this.setActiveState(checked);
      this.loadFrequencyOptions(cart, eligibleItems, checked);

      if (becameVisible) {
        trackNavigation('subscription_booster_view', formatMoney(savings), 'minicart_view');
      }
    }

    loadFrequencyOptions(cart, eligibleItems, checked) {
      var self = this;
      if (!this.frequencySelect) return;

      var loadToken = ++this.frequencyLoadToken;

      getCommonFrequenciesForCart(cart, this.config).then(function (frequencies) {
        if (loadToken !== self.frequencyLoadToken) return;

        var cartFreq = checked ? getCartSubscriptionFrequency(eligibleItems) : null;
        var storedFreq = sessionStorage.getItem(STORAGE_KEY_FREQUENCY);
        var selectedFreq = populateFrequencySelect(
          self.frequencySelect,
          frequencies,
          cartFreq || storedFreq,
          self.config.defaultFrequency
        );

        if (selectedFreq) {
          sessionStorage.setItem(STORAGE_KEY_FREQUENCY, selectedFreq);
        }
      }).catch(function () {});
    }

    onToggleChange(checked) {
      var self = this;

      // Checkbox already flipped natively — revert if we can't process yet.
      if (this.isProcessing || isBoosterUpdating()) {
        if (this.toggle) this.toggle.checked = !checked;
        return;
      }

      clearTimeout(this.savingsRefreshTimer);
      setBoosterUpdating(true);
      this.setLoading(true);
      this.setActiveState(checked);

      var ready = discountUpdateInFlight
        ? discountUpdateInFlight.catch(function () { return null; })
        : Promise.resolve();

      ready
        .then(function () {
          return fetch('/cart.json', { credentials: 'same-origin' }).then(function (r) {
            if (!r.ok) throw new Error('Cart fetch failed');
            return r.json();
          });
        })
        .then(function (cart) {
          if (isToggleChecked(cart, self.config) === checked) {
            self.setActiveState(checked);
            return { skipped: true };
          }

          trackNavigation('subscription_booster_toggle', checked ? 'on' : 'off');

          var frequency = (self.frequencySelect && self.frequencySelect.value) || self.config.defaultFrequency;
          var switchPromise = checked
            ? switchAllToSubscription(cart, self.config, frequency)
            : switchAllToOneTime(cart, self.config);

          return switchPromise.then(function () {
            return { skipped: false };
          });
        })
        .then(function (result) {
          if (!result || result.skipped) return null;
          // Locked refresh: update booster UI without constructCart gift mutations.
          return refreshCart({ allowGiftSync: false });
        })
        .catch(function (err) {
          console.error('[SubscriptionBooster]', err);
          hideCartLoader();
          self.setActiveState(!checked);
        })
        .finally(function () {
          setBoosterUpdating(false);
          self.setLoading(false);
          // One unlocked refresh so gift add/remove can run exactly once.
          refreshCart({ allowGiftSync: true }).catch(function () {
            self.updateFromCart();
          });
        });
    }

    onFrequencyChange(frequency) {
      var self = this;
      if (this.isProcessing || isBoosterUpdating()) return;

      sessionStorage.setItem(STORAGE_KEY_FREQUENCY, String(frequency));
      trackNavigation('subscription_booster_frequency', frequency);
      setBoosterUpdating(true);
      this.setLoading(true);

      fetch('/cart.json', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          return updateSubscriptionFrequency(cart, self.config, frequency);
        })
        .then(function () {
          return refreshCart({ allowGiftSync: false });
        })
        .catch(function (err) {
          console.error('[SubscriptionBooster] frequency update', err);
          hideCartLoader();
        })
        .finally(function () {
          setBoosterUpdating(false);
          self.setLoading(false);
          refreshCart({ allowGiftSync: true }).catch(function () {
            self.updateFromCart();
          });
        });
    }

    openPopup() {
      if (this.popup) {
        this.popup.classList.remove('hide');
        document.body.classList.add('non-scroll');
      }
    }

    closePopup() {
      if (this.popup) {
        this.popup.classList.add('hide');
        document.body.classList.remove('non-scroll');
      }
    }
  }

  if (!customElements.get('subscription-booster')) {
    customElements.define('subscription-booster', SubscriptionBooster);
  }

  window.SubscriptionBooster = {
    update: function (cart) {
      var el = document.querySelector('[data-subscription-booster]');
      if (el && typeof el.render === 'function') {
        el.render(cart);
      }
    }
  };
})();
